import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { IFilter } from '../../types/filters';
import { AreaContainer } from '../../containers/filters/AreaContainer';

export const area: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: AreaContainer,
};
